import React, {RefObject} from 'react'

export type DropdownRootContextValue = {
  closeAfterSelection: boolean
  dropdownRef: RefObject<HTMLDivElement>
}
const DropdownRootContext = React.createContext<DropdownRootContextValue | null>(null)
export const useDropdownRootContext = (): DropdownRootContextValue => {
    const ctx = React.useContext(DropdownRootContext)
    if (!ctx) {
        throw new Error('useDropdownRootContext must be used within a DropdownRootProvider')
    }
    return ctx
}

export type DropdownMenuContextValue = {
  isOpen: boolean
  onToggle: (ev?: React.MouseEvent) => void;
}

const DropdownMenuContext = React.createContext<DropdownMenuContextValue | null>(null)
export const useDropdownMenuContext = (): DropdownMenuContextValue => {
    const ctx = React.useContext(DropdownMenuContext)
    if (!ctx) {
        throw new Error('useDropdownMenuContext must be used within a DropdownMenuProvider')
    }
    return ctx
}

export const DropdownRootProvider = DropdownRootContext.Provider
export const DropdownMenuProvider = DropdownMenuContext.Provider
